import { isHotkey } from '../../../../../../utilities/hotkeys/hotkeys.mjs';

/**
 * Factory to create a handler for a given hotkey
 */

function getHotkeyHandler(hotkey, handler) {
  return (event, editor) => {
    if (hotkey && isHotkey(event, hotkey)) {
      event.preventDefault();
      handler(editor);
    }
  };
}

export { getHotkeyHandler };
